import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Outcome} from '../Outcome';
import {OptionsModal} from '../OptionsModal';
import {Option} from './Option';
import {List} from './List';
import {TitleBlock} from './TitleBlock';
import {Title} from './Title';
import {Wrapper} from './Wrapper';

import './style.scss';

const SELECT_BUTTON_TEXT = 'Select experiment outcome';
const MODAL_NAME = 'Select an experiment outcome';

/**
 * ExperimentOutcomesModal:
 *  - Modal window for Experiment Outcome
 *  - It is used in the mobile
 */
export function ExperimentOutcomesModal(props) {
  const [selectedOption, setSelectedOption] = useState(undefined);

  const onSelectOption = (optionID) => () => setSelectedOption(optionID);

  const isOptionSelected = (optionID) => optionID === selectedOption;

  const renderOptions = (option) => {
    const className = `expOutcomeModalOption ${
      isOptionSelected(option.id) ? 'expOutcomeModalOption--selected' : ''
    }`;
    if (option.visible) {
      return (
        <Option
          key={option.id}
          selected={isOptionSelected(option.id)}
          className={className}
          onClick={onSelectOption(option.id)}>
          <Outcome
            title={option.title}
            image={option.image}
            glossaryId={option.glossaryId}
          />
        </Option>
      );
    } else return null;
  };

  const onSumbitSelection = () => {
    props.onAddStep({optionId: selectedOption});
  };

  const className = `${props.className} expOutcomeModal`;
  const optionSelectedClassName = `expOutcomeModal_contentWrapper ${
    selectedOption ? 'expOutcomeModal_contentWrapper--selected' : ''
  }`;
  return (
    <OptionsModal
      close={props.close}
      isOpen={props.isOpen}
      buttonText={SELECT_BUTTON_TEXT}
      isOptionSelected={!selectedOption}
      onSumbitSelection={onSumbitSelection}>
      <Wrapper className={className}>
        <TitleBlock className='expOutcomeModal_title'>
          <Title className='expOutcomeModal_title--title' title={MODAL_NAME} />
        </TitleBlock>
        <Wrapper className={optionSelectedClassName}>
          <List className='expOutcomeModal_contentWrapper__list'>
            {props.list.map(renderOptions)}
          </List>
        </Wrapper>
      </Wrapper>
    </OptionsModal>
  );
}

ExperimentOutcomesModal.propTypes = {
  /**
   * data to render on multiple Hexagon
   */
  list: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id number of the each component
       */
      id: PropTypes.number,
      /**
       * card type
       */
      type: PropTypes.string,
      /**
       * title of the Hex card to be rendered
       */
      title: PropTypes.string,
      /**
       * image file path
       */
      image: PropTypes.string,
    })
  ),
  /**
   * className for Experiment component
   */
  className: PropTypes.string,
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Fuction to close modal
   */
  close: PropTypes.func,
  /**
   * function to invoke when adding step in mobile View
   */
  onAddStep: PropTypes.func,
};

ExperimentOutcomesModal.defaultProps = {
  className: '',
  list: [],
};
